<zui-status-icon-base
  class="__icon-base"
  [size]="size"
  [status]="status"
  [statusText]="statusText"
  [tooltip]="tooltip"
  [pulsing]="pulsingStatusesMap[status]">
</zui-status-icon-base>
